// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Fbip","consentsList":"PatientConsents_consentsList__p7ayp","consentsListEmpty":"PatientConsents_consentsListEmpty__37VNI"};